var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7717 0.566083L36.7902 19.6285C37.3288 21.3344 38.6652 22.6708 40.3711 23.2094L59.4335 29.2279C60.1876 29.4658 60.1876 30.5336 59.4335 30.7715L40.3718 36.7913C38.6659 37.33 37.3295 38.6663 36.7909 40.3723L30.7717 59.4347C30.5338 60.1888 29.466 60.1888 29.2281 59.4347L23.2089 40.3723C22.6703 38.6663 21.3339 37.33 19.628 36.7913L0.565603 30.7722C-0.188494 30.5342 -0.188494 29.4665 0.565603 29.2286L19.628 23.2101C21.3339 22.6715 22.6703 21.3351 23.2089 19.6292L29.2281 0.566083C29.466 -0.188694 30.5338 -0.188694 30.7717 0.566083Z",
    fill: "url(#paint0_linear_1_867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_867",
    x1: 29.9996,
    y1: 0,
    x2: 29.9996,
    y2: 60.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.21b6447af9ea4e8125a456f18f55fae4.svg";
export { ForwardRef as ReactComponent };